// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b0b05d4","732":"fb06816a","977":"8886bed6"}[chunkId] + ".chunk.js";
};